"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SourceListItemPropTypes = void 0;
var _propTypes = require("prop-types");
var SourceListItemPropTypes = exports.SourceListItemPropTypes = {
  index: _propTypes.number,
  source: (0, _propTypes.shape)({
    _id: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired,
    type: _propTypes.string.isRequired,
    hidden: _propTypes.bool,
    title: _propTypes.string.isRequired
  }),
  enableFeature: _propTypes.bool.isRequired,
  onLiveClicked: _propTypes.func.isRequired,
  onFeaturedToggleClicked: _propTypes.func.isRequired,
  onMuteToggleClicked: _propTypes.func.isRequired,
  onLiveToggleClicked: _propTypes.func.isRequired,
  onSourceEdited: _propTypes.func.isRequired,
  onSourceDeleted: _propTypes.func.isRequired,
  live: _propTypes.bool,
  volume: _propTypes.number,
  loop: _propTypes.bool,
  isPlaying: _propTypes.bool,
  onSourceHidden: _propTypes.func.isRequired,
  onLoopToggleClicked: _propTypes.func.isRequired,
  onVolumeChanged: _propTypes.func.isRequired,
  isMuted: _propTypes.bool,
  isMaxUnhiddenCamerasOn: _propTypes.bool,
  onCameraToggleClicked: _propTypes.func.isRequired,
  isCameraOn: _propTypes.bool,
  isMaximumCameraSourcesOn: _propTypes.bool,
  isStaged: _propTypes.bool,
  onSourceStaged: _propTypes.func.isRequired,
  isStagedSourcesActive: _propTypes.bool,
  onReorderSources: _propTypes.func,
  dragAndDrop: _propTypes.bool,
  onDragSource: _propTypes.func,
  isDraggingSource: _propTypes.bool,
  prevSource: (0, _propTypes.shape)({
    type: _propTypes.string
  }),
  onThumbnailReady: _propTypes.func,
  onUploadClicked: _propTypes.func,
  attendeeNetworkHealth: _propTypes.object,
  visible: _propTypes.bool.isRequired,
  viewPermissions: _propTypes.object,
  user: _propTypes.object,
  attendeeTiles: _propTypes.object,
  meetingSession: _propTypes.object,
  isDirectorSource: _propTypes.bool,
  AttendeeTileComponent: _propTypes.elementType,
  maxCameraSourceLimit: _propTypes.number
};